function handleResponse(res) {
  if (res.status === 404) {
    res.json().then(() =>
      Promise.resolve({
        error: "No data",
      })
    );
  }
  if (res.status === 500) {
    return Promise.resolve({
      error: "An error occurred. We are working on it.",
    });
  }
  return res.json();
}

function handleDates(f) {
  const filters = { ...f };
  if (filters.billing === null) {
    delete filters.billing;
  }
  return {
    ...filters,
    startDate: filters.startDate.toISOString(),
    endDate: filters.endDate.toISOString(),
  };
}

function getQueryString(filters) {
  const metaParam = [];
  // convert filters object into a query string
  return `${Object.keys(filters)
    .map((key) => {
      if (key === "projectUUID") {
        if (filters[key]) {
          metaParam.push(`project:${filters[key]}`);
        }
        return "";
      }
      if (key === "broadcastUUID") {
        if (filters[key]) {
          metaParam.push(`broadcast:${filters[key]}`);
        }
        return "";
      }
      if (key === "inboundUUID") {
        if (filters[key]) {
          metaParam.push(`inbound:${filters[key]}`);
        }
        return "";
      }
      if (key === "eventUUID") {
        if (filters[key]) {
          metaParam.push(`event:${filters[key]}`);
        }
        return "";
      }
      if (key === "metaKind") {
        if (filters[key]) {
          metaParam.push(`kind:${filters[key]}`);
        }
        return "";
      }
      return `${key}=${filters[key]}`;
    })
    .join("&")}&withMetadata=1${
    metaParam.length > 0 ? `&meta=${metaParam.join(",")}` : ""
  }`;
}

// f is filters object from Filters component
export function getReportData(f) {
  const filters = handleDates(f);
  const queryString = getQueryString(filters);

  return fetch(`/reports/gateway/getGraphData?${queryString}`).then(
    handleResponse
  );
}
// https://dev.to/chandelieraxel/why-you-should-cancel-your-api-calls-in-react-410l
export function getTableData(f, controller) {
  const filters = handleDates(f);
  const queryString = getQueryString(filters);
  return fetch(
    `/reports/gateway/getTransactions?${queryString}`,
    controller && { signal: controller.signal }
  ).then(handleResponse);
}

export function getReplies({ transactionId, ...args }) {
  const queryString = getQueryString(args);

  return fetch(`/reports/gateway/replies/${transactionId}?${queryString}`).then(
    handleResponse
  );
}
